import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  Breadcrumb,
  Button,
  FileUploadV2,
  Notification,
  Icon,
  Modal,
  DataTable,
  TextInput,
} from "pepsico-ds";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import "./idx-attribute-bulk-load.css";

const IdxPreProdGroupMembership = () => {
 const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const { REACT_APP_API_ENDPOINT } = process.env;

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [showSuccessNotification, setShowSuccessNotification] = useState(false);
  const [showErrorModal, setErrorShowModal] = useState(false);
const [showValidationError, setShowValidationError] = useState(false);
const [isValid, setIsValid] = useState(false);
const [groupDNError, setGroupDNError] = useState("");
const [isSuccess, setIsSuccess] = useState(false);
const [isSubmitting, setIsSubmitting] = useState(false);

const [validationErrorCounts, setValidationErrorCounts] = useState({
  totalRow: 0,
  valid: 0,
  blankRow: 0,
  issues: 0,
});



const validationErrorColumns = [
  {
    columnKey: "row",
    header: t("idx.row"),
    showColumnVisibility: true,
    initialSize: 140,
  },
  {
    columnKey: "message",
    header: t("idx.message"),
    showColumnVisibility: true,
    initialSize: 360,
  },
];

const [validationErrorModalData, setValidationErrorModalData] = useState([]);

const [groupDN, setGroupDN] = useState("");

const closeModal = () => {
  setErrorShowModal(false);
};

useEffect(() => {
  if (uploadedFiles?.[0]) {
    handleValidation();
  }
}, [uploadedFiles]);


  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
  if (isSuccess) {
    const timer = setTimeout(() => {
      setIsSuccess(false);
      navigate("/home");
    }, 4000);

    return () => clearTimeout(timer);
  }
}, [isSuccess, navigate]);


const downloadTemplate = async () => {
  try {
    const response = await axios.get(
      `${REACT_APP_API_ENDPOINT.replace("/myidm", "")}bulk-load/csv/template?type=idxgroupmembership`,
      {
        responseType: "blob",
      }
    );

    const blob = new Blob([response.data]);

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;
    link.setAttribute(
      "download",
      "IDX_PreProd_Group_Membership.csv"
    );

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    toast.error(t("entraGuest.request_fail_message"));
  }
};

const validateGroupDN = (value) => {
  if (!value?.trim()) {
    return "Group DN is required";
  }

  const normalizedValue = value.replace(/\s+/g, "");

  if (!/^cn=.+,ou=groups,.+/i.test(normalizedValue)) {
    return "Group DN must start with 'cn=' and should contain 'ou=groups'";
  }

  return "";
};

const handleSubmit = async () => {
  if (isSubmitting) return;

  const error = validateGroupDN(groupDN);

  if (error) {
    setGroupDNError(error);
    return;
  }

  setIsSubmitting(true);

  try {
    const formData = new FormData();

    formData.append("csvFile", uploadedFiles[0]);
    formData.append("groupDN", groupDN);

    const response = await axios.post(
      `${REACT_APP_API_ENDPOINT}/user/submitIdxGroupMembership`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (
      response?.data?.status === "Failed" ||
      response?.data?.responseStatus === "Failed"
    ) {
      const rows =
        response?.data?.errorMessage?.match(
          /Row \d+:.*?(?=\s\|$)/g
        ) || [];

      if (rows.length > 0) {
        setValidationErrorCounts((prev) => ({
          ...prev,
          issues: rows.length,
        }));

        setValidationErrorModalData(
          rows.map((err) => ({
            row: err?.split(":")?.[0],
            message: err?.split(":")?.[1],
          }))
        );

        setShowValidationError(true);
      } else {
        toast.error(
          response?.data?.errorMessage ||
            t("entraGuest.request_fail_message")
        );
      }

      setIsSubmitting(false); // allow retry on failure
      return;
    }

    setShowSuccessNotification(true);
    setIsSuccess(true);

    setUploadedFiles([]);
    setGroupDN("");
    setIsValid(false);
    setShowValidationError(false);
    setValidationErrorModalData([]);

    setValidationErrorCounts({
      totalRow: 0,
      valid: 0,
      blankRow: 0,
      issues: 0,
    });

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

   
  } catch (error) {
    toast.error(t("entraGuest.request_fail_message"));
    setIsSubmitting(false); // allow retry
  }
};

const disableSubmit = () => {
  return (
    isSubmitting ||
    !(
      uploadedFiles.length > 0 &&
      groupDN?.trim() &&
      !groupDNError &&
      isValid
    )
  );
};



const handleValidation = async () => {
  try {
    const formData = new FormData();
    formData.append("file", uploadedFiles[0]);

    const response = await axios.post(
      `${REACT_APP_API_ENDPOINT.replace("/myidm", "")}/bulk-load/csv/validate?type=idxgroupmembership`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const responseValidate = response.data;

   if (responseValidate?.valid) {
  setIsValid(true);
  setShowValidationError(false);
  setValidationErrorModalData([]);

  setValidationErrorCounts({
    totalRow: 0,
    valid: 0,
    blankRow: 0,
    issues: 0,
  });
} else {
      setIsValid(false);

      if (
        responseValidate?.totalRows ||
        responseValidate?.acceptedRows ||
        responseValidate?.skippedRows ||
        responseValidate?.validationErrors?.length
      ) {
        setValidationErrorCounts({
          totalRow: responseValidate?.totalRows || 0,
          valid: responseValidate?.acceptedRows || 0,
          blankRow: responseValidate?.skippedRows || 0,
          issues: responseValidate?.validationErrors?.length || 0,
        });

        setShowValidationError(true);

        if (responseValidate?.validationErrors?.length) {
          setValidationErrorModalData(
            responseValidate.validationErrors.map((err) => ({
              row: err?.split(":")?.[0],
              message: err?.split(":")?.[1],
            }))
          );
        }
      }

      if (
        !responseValidate?.validationErrors?.length &&
        responseValidate?.status === "Failed" &&
        responseValidate?.errorMessage?.includes("Invalid CSV headers")
      ) {
        setValidationErrorModalData([
          {
            row: "Expected headers",
            message: responseValidate?.errorMessage?.split(":")?.[1],
          },
        ]);

        setValidationErrorCounts((prev) => ({
          ...prev,
          issues: 1,
        }));

        setShowValidationError(true);
      }
    }
  } catch (error) {
    toast.error(t("entraGuest.request_fail_message"));
    setIsValid(false);
  }
};

 const renderConfirmModal = () => {
        return (
            <div className="validation-error-modal">
                <Modal
                    size="large"
                    id=""
                    className={isMobile ? "mobile-view-request-modal hide-rows-per-page validation-error-modal" : "validation-error-modal hide-rows-per-page"}
                    closeOnOutsideClick = {false}
                    onCloseModal={closeModal}
                    showCloseButton
                    showModal={showErrorModal}
                    style={{}}
                    tertiaryButtonProps=""
                    showAuxiliaryButton={false}
                    showPrimaryButton={false}
                    showSecondaryButton={false}
                    title={`${t("idx.showing")} ${validationErrorCounts?.issues} ${t("idx.issues")}`}
                    type="fluid"
                >
                    <DataTable
                        className="datatable"
                        columns={validationErrorColumns}
                        key={i18n.language}
                        enableSorting={true}
                        data={validationErrorModalData}
                        pageIndex={0}
                        pageSize={10}
                        selection="single"
                        tableHeader=""
                        size="large"
                        showTableHeader={true}
                        showTitle={true}
                        showSearchOption={false}
                        showColumnFilters={false}
                        showDescription={false}
                        tableDescription=""
                        showPagination={true}
                        noDataDescriptionText=""
                    />
                </Modal>
            </div>
        )
    }

  return (
    <>
      <div className="idx-main-container">
        <div
          className={isMobile ? "row" : "container"}
          style={{
            background: "none",
            boxShadow: "none",
            justifyContent: isMobile ? "center" : "",
          }}
        >
          <div
            style={{
              width: "100%",
              flex: 1,
            }}
          >
           {isSuccess && (
  <Notification
    className="mb-3"
    primaryActionOnClick={() => {}}
    secondaryActionOnClick={() => {}}
    showActionButtons={false}
    showIcon
    showText={false}
    showTitle
    title={t("idx.request_submitted_successfully")}
    type="success"
  />
)}

            <div
              className={`${
                isMobile ? "pl-4 pr-4 ml-4 mr-4" : ""
              } ad-main-heading-container`}
            >
              <Breadcrumb
                homeIcon={{
                    icon: "home",
                    onClick:()=>{
                    navigate("/home")
                    }
                }}
                breadcrumbs={[
                  {
                    label: "Home",
                  },
                  {
                    label: t("idx.idx_preprod_group_membership"),
                  },
                ]}
                className="idx-breadcrumb"
                useAnchor
              />

              <div className="ad-page-header">
                <div className="ad-main-heading">
                  {t("idx.idx_preprod_group_membership")}
                </div>
              </div>
            </div>

            <div
              className="card-layout reg-card mb-3 mb-md-0 active-directory-card-container idx-container"
              style={{
                flex: isMobile ? "unset" : "0 0 calc(66.666% - 7.5px)",
                width: isMobile ? "100%" : "auto",
                flexDirection: isMobile ? "column" : "row",
                gap: "1rem",
              }}
            >
              <div className="w-100">
                <div className="card card-content align-items-center">
                  <div className="bulk-upload-section testid-form-section">
                    {/* Download Template */}

                    <div className="download-template-section">
                      <div className="download-template-label">
                        <Icon icon="download" size="18px" />

                        <div className="d-flex flex-column text-left">
                          <div className="download-template-heading">
                            {t("idx.download_the_excel_template")}
                          </div>
                        </div>
                      </div>

                      <Button
                        size="large"
                        text={t("entraGuest.download")}
                        variant="primary"
                        onClick={downloadTemplate}
                      />
                    </div>

                    {/* Upload */}

                    {/* <TextInput
  label={t("idx.group_dn")}
  placeholder="cn=groupName,ou=groups,ou=xyz,ou=applications,o=pepsico,dc=pep,dc=pvt"
  value={groupDN}
  onChange={(e) => setGroupDN(e.target.value)}
  required
/> */}

                    <FileUploadV2
  accept=".csv"
  buttonLabel={t("idx.file_upload")}
  description={t("idx.drag_drop_file_here")}
  label={t("idx.file_upload")}
  type="default"
  uploadIcon="cloud_upload"
  helperText={t("idx.maximum_of_50_gpids")}
  uploadedFilesLabel={t("entraGuest.uploaded_files")}
  variant="complete"
  isShowUploadedFileCount={false}
  files={uploadedFiles}
  multiple={false}
  required
  disabled={uploadedFiles.length > 0}
  onUpdate={(file) => {
    setUploadedFiles([file]);

    setShowValidationError(false);
    setValidationErrorModalData([]);
    setValidationErrorCounts({
      totalRow: 0,
      valid: 0,
      blankRow: 0,
      issues: 0,
    });

    setIsValid(false);
  }}
  onDelete={(index) => {
    const updatedFiles = uploadedFiles.filter(
      (_, i) => i !== index
    );

    setUploadedFiles(updatedFiles);
    setErrorShowModal(false);
    setShowValidationError(false);
    setValidationErrorModalData([]);
    setValidationErrorCounts({
      totalRow: 0,
      valid: 0,
      blankRow: 0,
      issues: 0,
    });

    setIsValid(false);
  }}
/>


                      {
                                                showValidationError ?
                                                <div className="idx-validation-error-section">
                                                    <Icon
                                                        alt="alt value"
                                                        icon="error"
                                                        size="18px"
                                                        className="main-icon"
                                                    />
                                                    <div className="idx-validation-error-main-section">
                                                        <div className="error-heading mb-2">{t("idx.validation_failed")}</div>
                                                        <div className="error-desc mb-2">{t("idx.validation_failed_desc")}</div>
                                                        <div className="error-tags-section">
                                                            <div className="total-row-tag">
                                                                <Icon
                                                                    alt="alt value"
                                                                    icon="table_rows"
                                                                    size="18px"
                                                                    className=""
                                                                />
                                                                <div>{`${validationErrorCounts?.totalRow} ${t("idx.total_rows")}`}</div>
                                                            </div>
                                                            <div className="valid-tag">
                                                                <Icon
                                                                    alt="alt value"
                                                                    icon="check"
                                                                    size="18px"
                                                                    className=""
                                                                />
                                                                <div>{`${validationErrorCounts?.valid} ${t("idx.valid")}`}</div>
                                                            </div>
                                                            <div className="blank-row-tag">
                                                                <Icon
                                                                    alt="alt value"
                                                                    icon="border_clear"
                                                                    size="18px"
                                                                    className=""
                                                                />
                                                                <div>{`${validationErrorCounts?.blankRow} ${t("idx.blank_rows")}`}</div>
                                                            </div>
                                                            <div className="issues-tag">
                                                                <Icon
                                                                    alt="alt value"
                                                                    icon="error"
                                                                    size="18px"
                                                                    className=""
                                                                />
                                                                <div>{`${validationErrorCounts?.issues} ${t("idx.issues")}`}</div>
                                                            </div>
                                                          <div
  className={`show-issues-tag ${
    !validationErrorModalData.length ? "disabled" : ""
  }`}
  onClick={() => {
    if (validationErrorModalData.length) {
      setErrorShowModal(true);
    }
  }}
>
  {t("idx.show_issues")}
</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                : null
                                            }

                    {/* DN Format */}

                                   {/* <TextInput
  label={t("idx.group_dn")}
  placeholder="cn=groupName,ou=groups,ou=xyz,ou=applications,o=pepsico,dc=pep,dc=pvt"
  value={groupDN}
  onChange={(e) => setGroupDN(e.target.value)}
  required
/> */}

<TextInput
  label={t("idx.group_dn")}
  placeholder="cn=groupName,ou=groups,ou=xyz,ou=applications,o=pepsico,dc=pep,dc=pvt"
  value={groupDN}
  onChange={(e) => {
    const value = e.target.value;
    setGroupDN(value);

    setGroupDNError(validateGroupDN(value));
  }}
  onBlur={() => {
    setGroupDNError(validateGroupDN(groupDN));
  }}
  required
/>
{groupDNError && (
  <div
    style={{
      color: "#D92D20",
      fontSize: "12px",
      marginTop: "4px",
      textAlign:"start"
    }}
  >
    {groupDNError}
  </div>
)}


                    <div
                      className="download-template-section"
                      style={{
                        marginTop: "16px",
                        marginBottom: "0",
                        background: "#F5F9FF",
                        border: "1px solid #8DB2E5",
                      }}
                    >
                      <div className="download-template-label">
                        <Icon icon="info" size="18px" />

                        <div className="d-flex flex-column text-left">
                          <div
                            className="download-template-heading"
                            style={{
                              fontSize: "14px",
                            }}
                          >
                            {t("idx.dn_format_example")}
                          </div>

                          <div className="download-template-desc">
                            cn=groupName, ou=groups, ou=xyz, ou=applications,
                            o=pepsico, dc=pep, dc=pvt
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="idx-footer mt-3">
        <div className="row footer-row-with-footer-buttons">
          <div className="footer-buttons">
            <div className="col-md-auto align-self-center d-flex mb-3 mb-md-0 px-md-0 justify-content-center">
              <Button
                className="search-user-cancel-button mr-md-2 my-0"
                size="medium"
                text={t("RequestGPIDForNonEmployee.cancel_btn_label")}
                variant="tertiary"
                onClick={() => navigate(-1)}
              />
            </div>

            <div className="col-md-auto align-self-center d-flex mb-3 mb-md-0">
              <Button
                className="search-user-select-button request-button my-0 px-3 justify-content-center"
                size="medium"
                text={t("nonArExtension.submit")}
                variant="primary"
                disabled={disableSubmit()}
                onClick={handleSubmit}
              />
            </div>
          </div>
        </div>

        <ToastContainer position="bottom-center" />
         {showErrorModal && renderConfirmModal()}
      </div>
    </>
  );
};

export default IdxPreProdGroupMembership;
